import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button } from "../shadcn/ui/button";
import { Input } from "../shadcn/ui/input";
import { Label } from "../shadcn/ui/label";
import { Textarea } from "../shadcn/ui/textarea";
import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from '../shadcn/ui/tooltip';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../shadcn/ui/accordion';
// import MediaViewDialog from '../Components/Dialog/MediaViewDialog';
import MediaDialog from '../Components/MediaDialog';
import { Link } from 'react-router-dom';

function Settings() {
    const [settings, setSettings] = useState({
        site_name: '',
        meta_description: '',
        meta_keywords: '',
        canonical_url: '',
        robots_meta: '',
        og_title: '',
        og_description: '',
        og_image: '',
        fb_app_id: '',
    });
    const [imagePreview, setImagePreview] = useState(settings?.og_image || null);
    const [loading, setLoading] = useState(true);
    const [isMediaDialogOpen, setIsMediaDialogOpen] = useState(false);
    const [isViewDialogOpen, setIsViewDialogOpen] = useState(false);
    const [selectedMedia, setSelectedMedia] = useState(null);

    const handleViewMedia = (mediaItem) => {
        setSelectedMedia(mediaItem);
        setIsViewDialogOpen(true);
    };

    const handleMediaSelect = (selectedMedia) => {
        const imageUrl = selectedMedia[0].full_file_path;
        setSettings((prev) => ({ ...prev, og_image: imageUrl }));
        setImagePreview(imageUrl);
        setIsMediaDialogOpen(false);
    };

    useEffect(() => {
        axios.get('/api/settings')
            .then(response => {
                setSettings(response.data);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching settings:', error);
                setLoading(false);
            });
    }, []);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setSettings(prevSettings => ({
            ...prevSettings,
            [name]: value,
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        axios.post('/api/settings', settings)
            .then(() => alert('Settings updated successfully'))
            .catch(error => console.error('Error updating settings:', error));
    };

    // if (loading) return <p>Loading...</p>;

    return (
        <>
            <div className="settings-container container mx-auto px-4 py-6">
                <h1 className="text-2xl font-bold mt-4">Διαμόρφωση</h1>
                <TooltipProvider>
                    <div>
                        <Accordion type="single" collapsible className="w-full mt-4">
                            {/* General Information Section */}
                            <AccordionItem value="general-info">
                                <AccordionTrigger>General Information</AccordionTrigger>
                                <AccordionContent>
                                    <div className="grid gap-4 py-4 sm:grid-cols-1 md:grid-cols-2">
                                        <div className="flex flex-col">
                                            <Label htmlFor="site_name">Site Name</Label>
                                            <Input
                                                id="site_name"
                                                name="site_name"
                                                value={settings.site_name}
                                                onChange={handleChange}
                                                className="input-field"
                                            />
                                        </div>
                                        <div className="flex flex-col">
                                            <Label htmlFor="meta_description">Meta Description</Label>
                                            <Textarea
                                                id="meta_description"
                                                name="meta_description"
                                                value={settings.meta_description}
                                                onChange={handleChange}
                                                className="textarea-field"
                                            />
                                        </div>
                                    </div>
                                </AccordionContent>
                            </AccordionItem>

                            {/* SEO Information Section */}
                            <AccordionItem value="seo-info">
                                <AccordionTrigger>SEO Information</AccordionTrigger>
                                <AccordionContent>
                                    <div className="grid gap-4 py-4 sm:grid-cols-1 md:grid-cols-2">
                                        <div className="flex flex-col">
                                            <Label htmlFor="meta_keywords" className="flex items-center">
                                                Meta Keywords
                                                <Tooltip>
                                                    <TooltipTrigger>
                                                        <span className="info-icon">?</span>
                                                    </TooltipTrigger>
                                                    <TooltipContent>
                                                        Comma-separated list of keywords.
                                                    </TooltipContent>
                                                </Tooltip>
                                            </Label>
                                            <Input
                                                id="meta_keywords"
                                                name="meta_keywords"
                                                value={settings.meta_keywords}
                                                onChange={handleChange}
                                                className="input-field"
                                            />
                                        </div>
                                        <div className="flex flex-col">
                                            <Label htmlFor="canonical_url" className="flex items-center">
                                                Canonical URL
                                                <Tooltip>
                                                    <TooltipTrigger>
                                                        <span className="info-icon">?</span>
                                                    </TooltipTrigger>
                                                    <TooltipContent>
                                                        Preferred URL to prevent duplicate content.
                                                    </TooltipContent>
                                                </Tooltip>
                                            </Label>
                                            <Input
                                                id="canonical_url"
                                                name="canonical_url"
                                                value={settings.canonical_url}
                                                onChange={handleChange}
                                                className="input-field"
                                            />
                                        </div>
                                        <div className="flex flex-col">
                                            <Label htmlFor="robots_meta" className="flex items-center">
                                                Robots Meta
                                                <Tooltip>
                                                    <TooltipTrigger>
                                                        <span className="info-icon">?</span>
                                                    </TooltipTrigger>
                                                    <TooltipContent>
                                                        Instructions for web crawlers.
                                                    </TooltipContent>
                                                </Tooltip>
                                            </Label>
                                            <Input
                                                id="robots_meta"
                                                name="robots_meta"
                                                value={settings.robots_meta}
                                                onChange={handleChange}
                                                className="input-field"
                                            />
                                        </div>
                                    </div>
                                </AccordionContent>
                            </AccordionItem>

                            {/* Open Graph Section */}
                            <AccordionItem value="og-info">
                                <AccordionTrigger>Open Graph Tags</AccordionTrigger>
                                <AccordionContent>
                                    <div className="grid gap-4 py-4 sm:grid-cols-1 md:grid-cols-2">
                                        <div className="flex flex-col">
                                            <Label htmlFor="og_title">OG Title</Label>
                                            <Input
                                                id="og_title"
                                                name="og_title"
                                                value={settings.og_title}
                                                onChange={handleChange}
                                                className="input-field"
                                            />
                                        </div>
                                        <div className="flex flex-col">
                                            <Label htmlFor="og_description">OG Description</Label>
                                            <Textarea
                                                id="og_description"
                                                name="og_description"
                                                value={settings.og_description}
                                                onChange={handleChange}
                                                className="textarea-field"
                                            />
                                        </div>
                                        {/* <div className="flex flex-col">
                                        <Label htmlFor="og_image">OG Image URL</Label>
                                        <Input
                                            id="og_image"
                                            name="og_image"
                                            value={settings.og_image}
                                            onChange={handleChange}
                                            className="input-field"
                                        />
                                    </div> */}
                                        {/* Image Row */}
                                        <div className="flex flex-col">
                                            <Label htmlFor="og_image" className="text-left mb-1">
                                                OG Image URL
                                            </Label>
                                            {imagePreview && (
                                                <div className="mb-2">
                                                    <img onClick={() => handleViewMedia(settings?.og_image)} src={imagePreview} alt="Preview" className="max-h-20 rounded-md cursor-pointer" />
                                                </div>
                                            )}
                                            <Button variant="outline" className='h-10 w-40' onClick={() => setIsMediaDialogOpen(true)}>
                                                {settings.og_image || imagePreview ? 'Change Image' : 'Select Image'}
                                            </Button>
                                        </div>
                                    </div>
                                </AccordionContent>
                            </AccordionItem>

                            {/* Facebook Meta Tags Section */}
                            <AccordionItem value="facebook-info">
                                <AccordionTrigger>Facebook Meta Tags</AccordionTrigger>
                                <AccordionContent>
                                    <div className="grid gap-4 py-4 sm:grid-cols-1 md:grid-cols-2">
                                        <div className="flex flex-col">
                                            <Label htmlFor="fb_app_id">Facebook App ID</Label>
                                            <Input
                                                id="fb_app_id"
                                                name="fb_app_id"
                                                value={settings.fb_app_id}
                                                onChange={handleChange}
                                                className="input-field"
                                            />
                                        </div>
                                    </div>
                                </AccordionContent>
                            </AccordionItem>
                        </Accordion>
                    </div>
                </TooltipProvider>
                <Button className="float-right h-10 mt-4" onClick={handleSubmit}>
                    Save Settings
                </Button>


                <MediaDialog
                    isOpenMediaDialog={isMediaDialogOpen}
                    onCloseMediaDialog={() => setIsMediaDialogOpen(false)}
                    onSelectMedia={handleMediaSelect}
                    maxSelection={1}
                />
            </div>
            <Menu />
        </>
    );
}

export default Settings;


function Menu() {
  const [menuData, setMenuData] = useState({ menuItems: [], subMenuItems: [] });

  useEffect(() => {
    const fetchMenuData = async () => {
      try {
        const response = await fetch('/api/menu');
        const data = await response.json();
        setMenuData(data);
      } catch (error) {
        console.error("Error fetching menu data:", error);
      }
    };

    fetchMenuData();
  }, []);

  const handleChange = (event, type, index, subIndex) => {
    const { name, value } = event.target;
    setMenuData(prevData => {
      const updatedData = { ...prevData };
      if (type === 'menuItems') {
        if (subIndex !== undefined) {
          updatedData.menuItems[index].subItems[subIndex][name] = value;
        } else {
          updatedData.menuItems[index][name] = value;
        }
      } else if (type === 'subMenuItems') {
        updatedData.subMenuItems[index][name] = value;
      }
      return updatedData;
    });
  };

  return (
    <div className="settings-container px-7">
      <h1>Settings Page</h1>
      <Accordion type="single" collapsible className="w-full mt-4">

        {/* Accordion for Menu Items */}
        <AccordionItem value="menu-items">
          <AccordionTrigger>Menu</AccordionTrigger>
          <AccordionContent>
            {menuData.menuItems.map((item, index) => (
              <div key={index} className="flex flex-col mb-4">
                <div className="flex items-center space-x-4 mb-2">
                  <div className="flex-1">
                    <Label htmlFor={`menu-title-${index}`}>Title</Label>
                    <Input
                      id={`menu-title-${index}`}
                      name="title"
                      value={item.title}
                      onChange={(e) => handleChange(e, 'menuItems', index)}
                      className="input-field"
                    />
                  </div>
                  <div className="flex-1">
                    <Label htmlFor={`menu-link-${index}`}>Link</Label>
                    <Input
                      id={`menu-link-${index}`}
                      name="link"
                      value={item.link}
                      onChange={(e) => handleChange(e, 'menuItems', index)}
                      className="input-field"
                    />
                  </div>
                </div>

                {/* Render sub-items if they exist */}
                {item.subItems && (
                  <div className="ml-4">
                    <h3 className="mt-4 mb-2">Sub-Items</h3>
                    {item.subItems.map((subItem, subIndex) => (
                      <div key={subIndex} className="flex items-center space-x-4 mb-2">
                        <div className="flex-1">
                          <Label htmlFor={`submenu-title-${index}-${subIndex}`}>Sub-Item Title</Label>
                          <Input
                            id={`submenu-title-${index}-${subIndex}`}
                            name="title"
                            value={subItem.title}
                            onChange={(e) => handleChange(e, 'menuItems', index, subIndex)}
                            className="input-field"
                          />
                        </div>
                        <div className="flex-1">
                          <Label htmlFor={`submenu-link-${index}-${subIndex}`}>Sub-Item Link</Label>
                          <Input
                            id={`submenu-link-${index}-${subIndex}`}
                            name="link"
                            value={subItem.link}
                            onChange={(e) => handleChange(e, 'menuItems', index, subIndex)}
                            className="input-field"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </AccordionContent>
        </AccordionItem>

        {/* Accordion for Sub-Menu Items */}
        <AccordionItem value="sub-menu-items">
          <AccordionTrigger>Sub-Menu</AccordionTrigger>
          <AccordionContent>
            {menuData.subMenuItems.map((subItem, index) => (
              <div key={index} className="flex items-center space-x-4 mb-4">
                <div className="flex-1">
                  <Label htmlFor={`submenu-title-${index}`}>Title</Label>
                  <Input
                    id={`submenu-title-${index}`}
                    name="title"
                    value={subItem.title}
                    onChange={(e) => handleChange(e, 'subMenuItems', index)}
                    className="input-field mb-2"
                  />
                </div>
                <div className="flex-1">
                  <Label htmlFor={`submenu-link-${index}`}>Link</Label>
                  <Input
                    id={`submenu-link-${index}`}
                    name="link"
                    value={subItem.link}
                    onChange={(e) => handleChange(e, 'subMenuItems', index)}
                    className="input-field"
                  />
                </div>
              </div>
            ))}
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
}

